function makeMessageForUnknownError() {
	const loginError = document.createElement("div");
	loginError.className = "notice notice-error";
	loginError.innerHTML = "<p><strong>Error:</strong>An unknown error occurred while logging you in. Please try again.</p>";
	return loginError;
}
function insertLoginErrorMessage(block: Element, message: Element) {
	message.classList.toggle("login-error", true);
	const previousLoginError = block.querySelector(".login-error");
	if (previousLoginError) {
		previousLoginError.replaceWith(message);
	} else {
		block.prepend(message);
	}
}

function wireUpLoginFormBlock(block: Element) {
	block.classList.toggle("set-up", true);
	const form = block.querySelector("form");
	if (!form) {
		return;
	}

	block.addEventListener('submit', e => {
		e.preventDefault();
		if (form.classList.contains("in-progress")) {
			return;
		}
		form.classList.toggle("in-progress", true);
		for (const button of form.querySelectorAll<HTMLButtonElement|HTMLInputElement>("button,input:is([type='button'],[type='submit'])")) {
			button.disabled = true;
		}

		fetch(form.action, {method: 'post', body: new FormData(form)})
			.then(resp => {
				if (resp.redirected) {
					window.location.href = resp.url;
					throw "done";
				} else if (resp.status === 302) {
					window.location.href = document.baseURI; // This means that the form was submitted without a redirect_to parameter.
					throw "done";
				}
				return resp.text();
			})
			.then(resp => new DOMParser().parseFromString(resp, "text/html"))
			.then(resp => {
				insertLoginErrorMessage(block, resp.getElementById("login_error") ?? makeMessageForUnknownError());
			})
			.catch(err => {
				if (err !== "done") {
					console.error(err);
					insertLoginErrorMessage(block, makeMessageForUnknownError());
				}
			})
			.finally(() => {
				form.classList.remove("in-progress");
				for (const button of form.querySelectorAll<HTMLButtonElement|HTMLInputElement>("button,input:is([type='button'],[type='submit'])")) {
					button.disabled = false;
				}
			});
	})
}

document.addEventListener('DOMContentLoaded', () => {
	for (const block of document.querySelectorAll(".wp-block-plaudit-embeddable-login-form:not(.set-up)")) {
		wireUpLoginFormBlock(block);
	}
});
